"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function clearKnock(knock) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_CLEAR_KNOCK, knock);
}
var _default = exports["default"] = clearKnock;